import React, { useEffect, useState } from 'react'
import {
  Btn,
  CustomCalendar,
  CustomDropdown,
  CustomModal,
  InputNumeroDecimal,
  InputText,
} from '../../../../components'
import { postRetificarCiot } from '../../../../services/api/https/deliveries/ciot.http'
import {
  TIPOS_CARGA_CIOT,
  dataIsoParaDate,
  dateParaDataIso,
  estiloDicaCiot,
  rotuloCiot,
} from './ciot.util'

const camposDeclarados = ciot => {
  const dados = ciot.dados && typeof ciot.dados === 'object' ? ciot.dados : {}
  return {
    valor_frete: Number(ciot.valor_frete) || null,
    data_fim_viagem: ciot.data_fim_viagem ? String(ciot.data_fim_viagem).slice(0, 10) : null,
    peso_carga: Number(ciot.peso_carga) || null,
    codigo_natureza_carga: Number(dados.codigo_natureza_carga) || null,
    codigo_tipo_carga: Number(dados.codigo_tipo_carga) || null,
  }
}

export default function ModalRetificarCiot({ visible, ciot, onClose, onConcluido, onError }) {
  const [form, setForm] = useState({})
  const [enviando, setEnviando] = useState(false)

  useEffect(() => {
    if (!visible || !ciot) return
    const declarados = camposDeclarados(ciot)
    setForm({
      ...declarados,
      data_fim_viagem: dataIsoParaDate(declarados.data_fim_viagem),
      codigo_natureza_carga: declarados.codigo_natureza_carga
        ? String(declarados.codigo_natureza_carga).padStart(4, '0')
        : '',
    })
  }, [visible, ciot])

  if (!ciot) return null

  const alterar = (campo, valor) => setForm(prev => ({ ...prev, [campo]: valor }))

  const onBtnRetificarClicked = async () => {
    const declarados = camposDeclarados(ciot)
    const novos = {
      valor_frete: Number(form.valor_frete) || null,
      data_fim_viagem:
        form.data_fim_viagem instanceof Date ? dateParaDataIso(form.data_fim_viagem) : null,
      peso_carga: Number(form.peso_carga) || null,
      codigo_natureza_carga: Number(form.codigo_natureza_carga) || null,
      codigo_tipo_carga: Number(form.codigo_tipo_carga) || null,
    }
    const alterados = Object.keys(novos).reduce((campos, campo) => {
      if (novos[campo] && novos[campo] !== declarados[campo]) campos[campo] = novos[campo]
      return campos
    }, {})
    if (!Object.keys(alterados).length) {
      onError('Altere ao menos um campo para retificar o CIOT')
      return
    }

    setEnviando(true)
    try {
      const atualizado = await postRetificarCiot(ciot.id, alterados)
      onConcluido(atualizado, `CIOT ${rotuloCiot(atualizado)} retificado na ANTT`)
    } catch (error) {
      onError(error)
    } finally {
      setEnviando(false)
    }
  }

  return (
    <CustomModal
      isVisible={visible}
      header={`Retificar CIOT ${rotuloCiot(ciot)}`}
      style={{ width: '90vw', maxWidth: 650 }}
      onClose={onClose}
    >
      <div className="p-grid">
        <div className="p-col-12" style={estiloDicaCiot}>
          Só carga fracionada aceita retificação, e só dentro do prazo da ANTT. Os campos vêm com o
          que foi declarado; altere apenas o que mudou.
        </div>
        <div className="p-md-4 p-col-12">
          <InputNumeroDecimal
            label="Valor do frete (R$):"
            marginTop={10}
            value={form.valor_frete}
            onChange={value => alterar('valor_frete', value)}
          />
        </div>
        <div className="p-md-4 p-col-12">
          <CustomCalendar
            label="Fim da viagem:"
            value={form.data_fim_viagem}
            appendTo={document.body}
            onChange={value => alterar('data_fim_viagem', value)}
          />
        </div>
        <div className="p-md-4 p-col-12">
          <InputNumeroDecimal
            label="Peso da carga (kg):"
            marginTop={10}
            value={form.peso_carga}
            onChange={value => alterar('peso_carga', value)}
          />
        </div>
        <div className="p-md-4 p-col-12">
          <InputText
            label="Natureza da carga:"
            marginTop={10}
            value={form.codigo_natureza_carga || ''}
            onChange={value =>
              alterar('codigo_natureza_carga', value.replace(/\D/g, '').slice(0, 4))
            }
          />
        </div>
        <div className="p-md-8 p-col-12">
          <CustomDropdown
            optionLabel="label"
            options={TIPOS_CARGA_CIOT}
            value={TIPOS_CARGA_CIOT.find(item => item.value === Number(form.codigo_tipo_carga))}
            label="Tipo de carga:"
            onChange={value => alterar('codigo_tipo_carga', value ? value.value : null)}
          />
        </div>
        <div
          className="p-col-12"
          style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}
        >
          <Btn backgroundColor="#999999" onClick={onClose}>
            Voltar
          </Btn>
          <Btn isLoading={enviando} onClick={onBtnRetificarClicked}>
            Retificar CIOT
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}
